// Import of the module
import { parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table
export type RatingConversion = {
  id: number;
  original_rating: string;
  rating_type: string;
  conversion_rating: number | null;
  final_rating: string;
  created_at: string;
  updated_at: string;
};

// Definition of the columns
export const rating_conversion_columns: ColumnDef<RatingConversion>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "original_rating",
    header: "Original Rating",
    cell: ({ row }) => row.getValue("original_rating"),
  },
  {
    accessorKey: "rating_type",
    header: "Rating Type",
    cell: ({ row }) => row.getValue("rating_type"),
  },
  {
    accessorKey: "conversion_rating",
    header: "Converted Rating",
    cell: ({ row }) => {
      const val = row.getValue<number | null>("conversion_rating");
      return val != null ? Math.round(val).toString() : "";
    },
  },
  {
    accessorKey: "final_rating",
    header: "Final Rating",
    cell: ({ row }) => row.getValue("final_rating"),
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue<string>("created_at")),
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => parseDate(row.getValue<string>("updated_at")),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
